<div class="toggle-container" #toggleContainer>
  <div class="selected-border" #highlight></div>

  <button *ngFor="let title of titlesToggles; let i = index"
          #buttonRef
          (click)="selectTitle(i)"
          [class.selected]="i === selectedIndex">
    <span>{{ title }}</span>
  </button>
</div>
